import React from 'react'

const PageTitle = props => <p style={{ fontSize: 22, margin: '5px 0 10px 0' }}>{props.title}</p>

export default PageTitle
